/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type OpportunityStatus = typeof OpportunityStatus[keyof typeof OpportunityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OpportunityStatus = {
  Draft: 'Draft',
  Shared: 'Shared',
  Closed: 'Closed',
} as const;
